import {StyledServiceOrderDrawerOrderInfoOrderDetails} from "../../../card/drawer/order-info/styles";

export type CustomerServiceOrderDrawerOrderInfoOrderDetailsProps = {
  coachName: string;
  price: string;
  deliveryInfo: string;
};

export function CustomerServiceOrderDrawerOrderInfoOrderDetails({
  coachName,
  price,
  deliveryInfo,
}: CustomerServiceOrderDrawerOrderInfoOrderDetailsProps) {
  return (
    <StyledServiceOrderDrawerOrderInfoOrderDetails>
      <div className="order-details-item-row">
        <p className="order-details-item">
          Creator: <span className="order-details-item-value">{coachName}</span>
        </p>
        <p className="order-details-item">
          Price: <span className="order-details-item-value">{price}</span>
        </p>
      </div>

      <div className="order-details-item-row">
        <p className="order-details-item">
          Est. delivery date:{" "}
          <span className="order-details-item-value">{deliveryInfo}</span>
        </p>
      </div>
    </StyledServiceOrderDrawerOrderInfoOrderDetails>
  );
}
